const funcion8 = {
    titulo: `Función: expresión de función`,
    problemas: [
      {
        codigo:1,
        descripcion: `Hemos visto que para declarar una función utilizamos la sintaxis:
<pre>        
function mostrarMensaje() {
  console.log("Hola mundo")
}
</pre>
Existe otra sintaxis para declarar una función en JavaScript que se llama expresión de función y se logra asignando a una variable el algoritmo de una función:
<pre>
const mostrarMensaje = function() {
    console.log("Hola mundo")
}
</pre>
Es decir declaramos una variable y le asignamos la función propiamente dicha (sin especificar un nombre). Luego llamamos a la función con la sintaxis que ya conocemos a través de la variable en este caso. `,
programa: `const mostrarMensaje = function () {
  console.log("Hola mundo")
}

mostrarMensaje()`,
        solucion: "'Hola mundo'"
      },{
        codigo:2,
        descripcion: `Una diferencia fundamental entre la declaración de una función y la expresión de una función es que ésta última se la puede llamar solo después que se inicializa la variable. El siguiente ejemplo genera un error en tiempo de ejecución:`,
programa: `mostrarMensaje()

const mostrarMensaje = function () {
  console.log("Hola mundo")
}`,
        solucion: ""
      },{
        codigo:3,
        descripcion: `Como se trata de una variable donde se guarda la referencia a una función, podemos asignar dicho valor a otra variable y llamar a la función desde la variable asignada.`,
programa: `const mostrarMensaje = function () {
  console.log("Hola mundo")
}

const copia = mostrarMensaje
copia()`,
        solucion: "'Hola mundo'"
      },{
        codigo:4,
        descripcion: `Podemos pasar como parámetro la variable que contiene la referencia a la función.`,
programa: `const mostrarMensaje = function () {
    console.log("Hola mundo")
  }

  function ejecutar(fn) {
    fn()
  }

  ejecutar(mostrarMensaje)`,
        solucion: "'Hola mundo'"
      },{
        codigo:5,
        descripcion: `Podemos crear una u otra función dependiendo de una condición.`,
programa: `let operacion = "perimetro"

let calcular
if (operacion === "perimetro") {
  calcular = function (lado) {
    return lado * 4
  }
} else {
  calcular = function (lado) {
    return lado * lado
  }
}
console.log(calcular(10))`,
        solucion: "40"
      }
    ]
  }

export default funcion8;